export const validateMaxLength = ({ maxLength }, value) => (
  !value || (value.length <= maxLength)
    ? Promise.resolve()
    : Promise.reject(new Error(`${value.length - maxLength} characters over`))
);
